import { useEffect, useState } from "react";
import { CONTACT } from "@/data/site";

export default function WhatsAppButton() {
  const [lifted, setLifted] = useState(false);

  useEffect(() => {
    const onBanner = (e) => setLifted(Boolean(e.detail));
    window.addEventListener("hm-cookie-banner", onBanner);
    return () => window.removeEventListener("hm-cookie-banner", onBanner);
  }, []);

  return (
    <a
      href={CONTACT.whatsapp}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-button"
      aria-label="Scrie-ne pe WhatsApp"
      className={`group fixed right-4 z-50 block transition-[bottom] duration-500 sm:right-6 ${
        lifted ? "bottom-56 sm:bottom-28" : "bottom-6"
      }`}
    >
      <span
        aria-hidden
        className="absolute inset-0 rounded-full bg-[#25D366] opacity-30 motion-safe:animate-ping [animation-duration:2.4s]"
      />
      <span className="relative flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] shadow-lg shadow-black/25 transition-transform duration-300 group-hover:scale-110">
        <img src="/whatsapp.svg" alt="" className="h-7 w-7" />
      </span>
      <span className="pointer-events-none absolute right-[4.5rem] top-1/2 -translate-y-1/2 whitespace-nowrap rounded-md border border-ink/10 bg-surface px-3 py-1.5 text-[11px] font-medium uppercase tracking-widest text-ink opacity-0 shadow-lg shadow-black/10 transition-opacity duration-300 group-hover:opacity-100">
        WhatsApp
      </span>
    </a>
  );
}
